import React, { useState } from 'react';
import '../styles/faqs.css';
import AnimationBox from '../animationBox';
import AnimatedButton from './AnimatedButton';
import { FaPlus } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
const Faqs = () => {
  const location = useLocation();
  const [selectedQuestion, setSelectedQuestion] = useState('What are the Advantages?');
  const value = location.pathname=='/Robotics-AboutUs'?true:false;

  // Questions and answers data
  const faqData = [
    {
      question: 'What are the Advantages?',
      answer: 'Cost Effectiveness \n Improved Quality Assurance \n Increased Productivity \n Work in Dangerous Environments',
    },
    {
      question: 'Is Automation Expensive?',
      answer: 'Automation can be cost-effective in the long run as it reduces labor costs and increases efficiency, though initial setup costs may vary depending on the complexity of the system.',
    },
    {
      question: 'How Much do Robots Cost?',
      answer: 'The cost of robots depends on their type and application. Industrial robots can range from $50,000 to $150,000, excluding maintenance and integration expenses.',
    },
  ];

  // Function to handle the click and change the selected question
  const handleQuestionClick = (question) => {
    setSelectedQuestion(question);
  };

  return (
    <div id={value?'':'horecafaq'} className='faqs' >
      <AnimationBox>
        <div className='inner-container'>
          { value?(<>
          <h4 className='faqs-heading'>Automation FAQ</h4>

          <div className='faqcontainer'>
            <div className="box">
              <h2>Frequently Asked Questions</h2>
            </div>
            <div className="box">
              <p>Find quick answers to common questions about our platform</p>
            </div>
          </div>

          <div className='faqcontainer faq-box'>
            <div className="box questions">
              {faqData.map((faq, index) => (
                <div className='question' key={index}>
                  <div>{faq.question}</div>
                  <div className="social-links">
                    <div className="icons">
                      <button 
                        aria-label="Expand Answer" 
                        onClick={() => handleQuestionClick(faq.question)}
                      >
                        <FaPlus />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="box answer">
              <div className='answer-box'>
                <h4>{selectedQuestion}</h4>
                <hr />
                <h6 className='faq-answer'>
      {faqData
        .find((faq) => faq.question === selectedQuestion)
        ?.answer.split('\n')
        .map((line, index) => (
          <span key={index}>
            {line}
            <br />
          </span>
        ))}
    </h6>
              </div>
            </div>
          </div></>):<></>
}
          <div className="gradient-div">
            <div className='left-lines'>
              <div className='right-lines'>
                <div className='bottom-circle'>
                  <div className="myp">
                    <h2>Join the Future of Robotic Automation</h2>
                  </div>
                  <AnimatedButton text="Contact Us" link="/Robotics-Contact" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </AnimationBox>
    </div>
  );
};

export default Faqs;
